module.exports = __webpack_public_path__ + "img/logo.be26cd17.svg";